import React from "react";
import PropTypes from "prop-types";
import { Anchor } from "discover.medical.react-component-library";
import { Link as RouterLink } from "react-router-dom";
import TextItem from "../TextItem";

const ListItem = ({ label, href, onClick }) => {
  if (!href) {
    return <TextItem label={label} />;
  }

  return (
    <Anchor
      fontSize="sm"
      href={href}
      linkComponent={RouterLink}
      onClick={onClick}
      data-testid="list-link"
    >
      <TextItem label={label} />
    </Anchor>
  );
};

ListItem.propTypes = {
  label: PropTypes.string.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
};

export default ListItem;
